function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Coordinate from '../../geom/Coordinate';
import Polygon from '../../geom/Polygon';
import RectangleLineIntersector from '../../algorithm/RectangleLineIntersector';
import ShortCircuitedGeometryVisitor from '../../geom/util/ShortCircuitedGeometryVisitor';
import SimplePointInAreaLocator from '../../algorithm/locate/SimplePointInAreaLocator';
import LinearComponentExtracter from '../../geom/util/LinearComponentExtracter';
var RectangleIntersects = /*#__PURE__*/function () {
  function RectangleIntersects() {
    _classCallCheck(this, RectangleIntersects);
    RectangleIntersects.constructor_.apply(this, arguments);
  }
  return _createClass(RectangleIntersects, [{
    key: "intersects",
    value: function intersects(geom) {
      if (!this._rectEnv.intersects(geom.getEnvelopeInternal())) return false;
      var visitor = new EnvelopeIntersectsVisitor(this._rectEnv);
      visitor.applyTo(geom);
      if (visitor.intersects()) return true;
      var ecpVisitor = new GeometryContainsPointVisitor(this._rectangle);
      ecpVisitor.applyTo(geom);
      if (ecpVisitor.containsPoint()) return true;
      var riVisitor = new RectangleIntersectsSegmentVisitor(this._rectangle);
      riVisitor.applyTo(geom);
      if (riVisitor.intersects()) return true;
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleIntersects;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "intersects",
    value: function intersects(rectangle, b) {
      var rp = new RectangleIntersects(rectangle);
      return rp.intersects(b);
    }
  }]);
}();
export { RectangleIntersects as default };
RectangleIntersects.constructor_ = function () {
  this._rectangle = null;
  this._rectEnv = null;
  var rectangle = arguments[0];
  this._rectangle = rectangle;
  this._rectEnv = rectangle.getEnvelopeInternal();
};
var EnvelopeIntersectsVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet) {
  function EnvelopeIntersectsVisitor() {
    var _this;
    _classCallCheck(this, EnvelopeIntersectsVisitor);
    _this = _callSuper(this, EnvelopeIntersectsVisitor);
    EnvelopeIntersectsVisitor.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(EnvelopeIntersectsVisitor, _ShortCircuitedGeomet);
  return _createClass(EnvelopeIntersectsVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._intersects === true;
    }
  }, {
    key: "visit",
    value: function visit(element) {
      var elementEnv = element.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) {
        return null;
      }
      if (this._rectEnv.contains(elementEnv)) {
        this._intersects = true;
        return null;
      }
      if (elementEnv.getMinX() >= this._rectEnv.getMinX() && elementEnv.getMaxX() <= this._rectEnv.getMaxX()) {
        this._intersects = true;
        return null;
      }
      if (elementEnv.getMinY() >= this._rectEnv.getMinY() && elementEnv.getMaxY() <= this._rectEnv.getMaxY()) {
        this._intersects = true;
        return null;
      }
    }
  }, {
    key: "intersects",
    value: function intersects() {
      return this._intersects;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EnvelopeIntersectsVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(ShortCircuitedGeometryVisitor);
EnvelopeIntersectsVisitor.constructor_ = function () {
  this._rectEnv = null;
  this._intersects = false;
  var rectEnv = arguments[0];
  this._rectEnv = rectEnv;
};
var GeometryContainsPointVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet2) {
  function GeometryContainsPointVisitor() {
    var _this2;
    _classCallCheck(this, GeometryContainsPointVisitor);
    _this2 = _callSuper(this, GeometryContainsPointVisitor);
    GeometryContainsPointVisitor.constructor_.apply(_this2, arguments);
    return _this2;
  }
  _inherits(GeometryContainsPointVisitor, _ShortCircuitedGeomet2);
  return _createClass(GeometryContainsPointVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._containsPoint === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      if (!(geom instanceof Polygon)) return null;
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      var rectPt = new Coordinate();
      for (var i = 0; i < 4; i++) {
        this._rectSeq.getCoordinate(i, rectPt);
        if (!elementEnv.contains(rectPt)) continue;
        if (SimplePointInAreaLocator.containsPointInPolygon(rectPt, geom)) {
          this._containsPoint = true;
          return null;
        }
      }
    }
  }, {
    key: "containsPoint",
    value: function containsPoint() {
      return this._containsPoint;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryContainsPointVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(ShortCircuitedGeometryVisitor);
GeometryContainsPointVisitor.constructor_ = function () {
  this._rectSeq = null;
  this._rectEnv = null;
  this._containsPoint = false;
  var rectangle = arguments[0];
  this._rectSeq = rectangle.getExteriorRing().getCoordinateSequence();
  this._rectEnv = rectangle.getEnvelopeInternal();
};
var RectangleIntersectsSegmentVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet3) {
  function RectangleIntersectsSegmentVisitor() {
    var _this3;
    _classCallCheck(this, RectangleIntersectsSegmentVisitor);
    _this3 = _callSuper(this, RectangleIntersectsSegmentVisitor);
    RectangleIntersectsSegmentVisitor.constructor_.apply(_this3, arguments);
    return _this3;
  }
  _inherits(RectangleIntersectsSegmentVisitor, _ShortCircuitedGeomet3);
  return _createClass(RectangleIntersectsSegmentVisitor, [{
    key: "intersects",
    value: function intersects() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return this._hasIntersection === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      var lines = LinearComponentExtracter.getLines(geom);
      this.checkIntersectionWithLineStrings(lines);
    }
  }, {
    key: "checkIntersectionWithLineStrings",
    value: function checkIntersectionWithLineStrings(lines) {
      for (var i = lines.iterator(); i.hasNext();) {
        var testLine = i.next();
        this.checkIntersectionWithSegments(testLine);
        if (this._hasIntersection) return null;
      }
    }
  }, {
    key: "checkIntersectionWithSegments",
    value: function checkIntersectionWithSegments(testLine) {
      var seq1 = testLine.getCoordinateSequence();
      for (var j = 1; j < seq1.size(); j++) {
        seq1.getCoordinate(j - 1, this._p0);
        seq1.getCoordinate(j, this._p1);
        if (this._rectIntersector.intersects(this._p0, this._p1)) {
          this._hasIntersection = true;
          return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleIntersectsSegmentVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(ShortCircuitedGeometryVisitor);
RectangleIntersectsSegmentVisitor.constructor_ = function () {
  this._rectEnv = null;
  this._rectIntersector = null;
  this._hasIntersection = false;
  this._p0 = new Coordinate();
  this._p1 = new Coordinate();
  var rectangle = arguments[0];
  this._rectEnv = rectangle.getEnvelopeInternal();
  this._rectIntersector = new RectangleLineIntersector(this._rectEnv);
};